import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../images/img_4.png';
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "stats-container"
};
const _hoisted_3 = {
  class: "stat-item"
};
const _hoisted_4 = {
  class: "stat-value"
};
const _hoisted_5 = {
  class: "stat-item"
};
const _hoisted_6 = {
  class: "stat-value"
};
const _hoisted_7 = {
  ref: "myEchart",
  class: "myEchart"
};
import { ref, onMounted } from 'vue';
import axios from 'axios';
export default {
  __name: 'FooterView2',
  setup(__props) {
    const downloads = ref(0);
    const pageviews = ref(0);
    const fetchStats = async () => {
      try {
        const response = await axios.get('https://test.cyclostrat.org/Cyclic/showdownloads');
        console.log(response.data);
        pageviews.value = response.data.totalPageCount;
        downloads.value = response.data.totalDownCount;
      } catch (error) {
        console.error('获取统计信息失败:', error);
      }
    };
    onMounted(() => {
      fetchStats();
      // 监听更新事件
      // window.addEventListener('update-downloads', fetchStats);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "nav-logo-img"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(pageviews.value), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "stat-label"
      }, "Visits", -1))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(downloads.value), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "stat-label"
      }, "Downloads", -1))])]), _createElementVNode("div", _hoisted_7, null, 512)]);
    };
  }
};